export default "__VITE_ASSET__ea852170__"